import * as React from "react";
function SvgComponent(props) {
  return <svg {...props} viewBox="0 0 10 8" xmlns="http://www.w3.org/2000/svg" style={{
    fillRule: "evenodd",
    clipRule: "evenodd"
  }}><path d="M.928.221h8.117c.39 0 .707.317.707.707v6.088c0 .39-.317.707-.707.707H.928a.708.708 0 01-.707-.707V.928c0-.39.317-.707.707-.707zM5.584 5.68L3.596 3.511a.517.517 0 00-.769 0L.621 5.917V.928c0-.169.138-.307.307-.307h8.117c.17 0 .307.138.307.307v5.404L7.548 4.418a.53.53 0 00-.775 0L5.584 5.68z" style={{
      strokeWidth: ".11px"
    }} /><path d="M8.572 2.431a.913.913 0 11-1.825 0 .913.913 0 011.825 0z" style={{
      fillRule: "nonzero"
    }} /></svg>;
}
export default SvgComponent;